import { ecorEnv } from '@/../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { EcorrBanner } from './ecorr-banner';

@Injectable({
    providedIn: 'root'
})
export class EcorrBannerService {
    private http = inject(HttpClient);

    getActiveBanners(displayApp: string): Observable<EcorrBanner[]> {
        const url = `${ecorEnv.apiEndpoint}/banners?displayApp=${displayApp}`;
        return this.http.get<EcorrBanner[]>(url)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    private handleError = (error: any): Observable<never> => {
        let errorMessage = '';
        
        if (error.error instanceof ErrorEvent) {
            // Client-side error
            errorMessage = `Client Error: ${error.error.message}`;
        } else {
            // Server-side error
            errorMessage = `Server Error: ${error.status} - ${error.message}`;
        }
        
        console.error('[EcorrBannerService] Error:', errorMessage);
        return throwError(() => new Error(errorMessage));
    }

}
